<script>
	// Stores
	import SrmBetStore from '@/Stores/Racing/SrmBetStore.js';
	// Services
	import { getUrlParameter, setUrlParameter, paginationBuilder } from '@/Services/Helpers.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import Pagination from '@/Components/Pagination.svelte';
	import Modal from '@/Components/ModalFlex.svelte';
	// Partials
	import BetTickerRow from '@/Partials/Bets/_BetTickerRow.svelte';

	export let open;
	export let meeting;
	export let race;

	$: links = open && $SrmBetStore.count() && paginationBuilder(SrmBetStore.getPagination());
	$: open && getSrmBets();

	let pageNo = getUrlParameter('page') || 1;
	let pageSize = 50;
	//let loading = getSrmBets();
	let loading = false;

	function changePage(e) {
		if (e) {
			pageNo = e.detail.page;
			getSrmBets();
			setUrlParameter('page', pageNo);
		}
	}

	function getSrmBets() {
		loading = true;
		return SrmBetStore.getSrmBetsForRace(race.id, {
			size: pageSize,
			number: pageNo
		}).finally(() => (loading = false));
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)} className="mx-2 md:w-full max-h-full overflow-y-auto">
		<div>
			<div>
				<!-- Page Header -->
				<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
					<div class="flex items-center justify-between w-full">
						<h1 class="text-xl font-bold">
							{meeting && meeting.name} Race {race && race.race_number} - SRM Bets
						</h1>
					</div>
				</div>
				<!-- /Page Header -->
				<div class="p-2 mx-4 bg-gray-100 rounded">
					{#if loading}
						<div class="py-40">
							<Loading />
						</div>
					{:else}
						<div class="overflow-x-auto overflow-y-auto rounded">
							<table class="w-full">
								<thead>
									<tr class="text-xs text-left text-gray-500 uppercase">
										<th class="px-2 pt-5 pb-4 font-medium text-center">Ticket</th>
										<th class="px-2 pt-5 pb-4 font-medium text-center">Date</th>
										<th class="px-2 pt-5 pb-4 font-medium text-center">User</th>
										<th class="px-2 pt-5 pb-4 font-medium">Event</th>
										<th class="px-2 pt-5 pb-4 font-medium">Selection</th>
										<th class="px-2 pt-5 pb-4 font-medium">Bet</th>
										<th class="px-2 pt-5 pb-4 font-medium">Liability</th>
										<th class="px-2 pt-5 pb-4 font-medium">Return</th>
										<th class="px-2 pt-5 pb-4 font-medium">Net Win</th>
										<th class="px-2 pt-5 pb-4 font-medium text-center">Status</th>
										<th class="px-2 pt-5 pb-4 font-medium text-center" />
									</tr>
								</thead>
								<tbody class="bg-white">
									{#if !$SrmBetStore.count()}
										<tr>
											<td class="px-6 py-4 text-center border-t" colspan="10"> No SRM bets found. </td>
										</tr>
									{:else}
										{#each $SrmBetStore.all() as bet (bet.id)}
											<tr class="hover:bg-gray-100 focus-within:bg-gray-100">
												<BetTickerRow {bet} />
											</tr>
										{/each}
									{/if}
								</tbody>
							</table>
						</div>
						<Pagination {links} on:click={changePage} className="my-3" />
					{/if}
				</div>
			</div>
		</div>
	</Modal>
{/if}
